module.exports = __webpack_public_path__ + "static/img/bg11.f8ddb82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg11.jpg
// module id = aKTN
// module chunks = 0